import { DeviationSeverity } from '../../../../shared/deviations/types';
import {
  CustomerDashboardDeviationType,
  CustomerItem,
  CustomersDashboardData
} from './types';

const CUSTOMERS: CustomerItem[] = [
  {
    id: 101,
    debtorId: 'D-1001',
    name: 'Bouwbedrijf Noord B.V.',
    blocked: false,
    projectCount: 4,
    orderCount: 12,
    productionAmount: 684.5,
    invoicing: {
      invoicedTotalPrice: 92840,
      outstandingTotalPrice: 18450,
      overdueTotalPrice: 0
    }
  },
  {
    id: 102,
    debtorId: 'D-1002',
    name: 'Van Dijk Infra',
    blocked: false,
    projectCount: 3,
    orderCount: 9,
    productionAmount: 512.8,
    invoicing: {
      invoicedTotalPrice: 74620,
      outstandingTotalPrice: 12380,
      overdueTotalPrice: 4280
    }
  },
  {
    id: 103,
    debtorId: 'D-1003',
    name: 'Aannemersbedrijf De IJssel',
    blocked: true,
    projectCount: 2,
    orderCount: 5,
    productionAmount: 196.4,
    invoicing: {
      invoicedTotalPrice: 31870,
      outstandingTotalPrice: 9760,
      overdueTotalPrice: 9760
    }
  },
  {
    id: 104,
    debtorId: 'D-1004',
    name: 'Projectontwikkeling Centrum',
    blocked: false,
    projectCount: 5,
    orderCount: 16,
    productionAmount: 904.2,
    invoicing: {
      invoicedTotalPrice: 126540,
      outstandingTotalPrice: 24690,
      overdueTotalPrice: 0
    }
  },
  {
    id: 105,
    debtorId: 'D-1005',
    name: 'Woningbouw Salland',
    blocked: false,
    projectCount: 3,
    orderCount: 8,
    productionAmount: 438.7,
    invoicing: {
      invoicedTotalPrice: 68920,
      outstandingTotalPrice: 0,
      overdueTotalPrice: 0
    }
  },
  {
    id: 106,
    debtorId: 'D-1006',
    name: 'Betonwerken Oost',
    blocked: true,
    projectCount: 1,
    orderCount: 3,
    productionAmount: 88.6,
    invoicing: {
      invoicedTotalPrice: 18450,
      outstandingTotalPrice: 6350,
      overdueTotalPrice: 2180
    }
  },
  {
    id: 107,
    debtorId: 'D-1007',
    name: 'Hofman Civiele Techniek',
    blocked: false,
    projectCount: 2,
    orderCount: 6,
    productionAmount: 274.3,
    invoicing: {
      invoicedTotalPrice: 42780,
      outstandingTotalPrice: 8140,
      overdueTotalPrice: 0
    }
  },
  {
    id: 108,
    debtorId: 'D-1008',
    name: 'Stedelijke Ontwikkeling West',
    blocked: false,
    projectCount: 0,
    orderCount: 0,
    productionAmount: 0,
    invoicing: {
      invoicedTotalPrice: 12900,
      outstandingTotalPrice: 12900,
      overdueTotalPrice: 5340
    }
  }
];

export function createCustomersMockData(): CustomersDashboardData {
  const list = CUSTOMERS.map(customer => ({
    ...customer,
    invoicing: { ...customer.invoicing }
  }));
  const blockedCustomerCount = list.filter(customer => customer.blocked).length;
  const outstandingCustomerCount = list.filter(
    customer => customer.invoicing.outstandingTotalPrice > 0
  ).length;
  const overdueCustomerCount = list.filter(
    customer => customer.invoicing.overdueTotalPrice > 0
  ).length;

  return {
    summary: {
      customerCount: list.length,
      runningProjectCount: list.reduce(
        (total, customer) => total + customer.projectCount,
        0
      ),
      blockedCustomerCount
    },
    deviations: [
      {
        type: CustomerDashboardDeviationType.blocked,
        severity: DeviationSeverity.blocking,
        count: blockedCustomerCount
      },
      {
        type: CustomerDashboardDeviationType.outstandingInvoices,
        severity: DeviationSeverity.warning,
        count: outstandingCustomerCount
      },
      {
        type: CustomerDashboardDeviationType.overdueInvoices,
        severity: DeviationSeverity.blocking,
        count: overdueCustomerCount
      }
    ],
    list
  };
}
